// Icelandic
export default {
	'fabric.reactions.loading': 'Hleður inn ...',
	'fabric.reactions.more.emoji': 'Meira emoji',
	'fabric.reactions.error.unexpected': 'Eitthvað fór úrskeiðis',
};
